export const defaultState = {
  applealTypes: [],
  myAppeals: [],
  appeal: null,
  appealDetails: [],
  appealResolved: null,
};
